import { CanvasLayout } from "./canvasLayout";

export interface Size {
  height: number;
  width: number;
}

export interface Position {
  x: number;
  y: number;
}

export class CanvasMeasurements {
  constructor(
    readonly size: Size,
    private readonly sectorSize: number,
    private readonly padding: Size
  ) {}

  static create(
    canvasLayout: CanvasLayout,
    clientSize: Size,
    paddingPx: number
  ): CanvasMeasurements {
    const width = Math.round(
      clientSize.width * (canvasLayout.lines.x / CanvasLayout.minLines)
    );
    const height = Math.round(
      clientSize.height * (canvasLayout.lines.y / CanvasLayout.minLines)
    );

    let canvasSize = {
      width,
      height,
    };

    const innerSize = {
      width: clientSize.width - paddingPx * 2,
      height: clientSize.height - paddingPx * 2,
    };
    const sectorSize =
      Math.min(innerSize.height, innerSize.width) / CanvasLayout.minLines;

    const paddingWidth = Math.max(
      0,
      innerSize.width - canvasLayout.lines.x * sectorSize
    );
    const paddingHeight = Math.max(
      0,
      innerSize.height - canvasLayout.lines.y * sectorSize
    );
    const canvasPadding = {
      width: paddingWidth / 2,
      height: paddingHeight / 2,
    };

    canvasSize = {
      width: Math.round(
        Math.min(
          canvasSize.width,
          sectorSize * canvasLayout.lines.x + paddingPx * 2 + paddingWidth
        )
      ),
      height: Math.round(
        Math.min(
          canvasSize.height,
          sectorSize * canvasLayout.lines.y + paddingPx * 2 + paddingHeight
        )
      ),
    };

    return new CanvasMeasurements(canvasSize, sectorSize, canvasPadding);
  }

  getX(index: number): number {
    const x = Math.round(this.padding.width + index * this.sectorSize);
    return x;
  }

  getY(index: number): number {
    const y = Math.round(this.padding.height + index * this.sectorSize);
    return y;
  }

  getLengthX(units: number): number {
    return Math.round(units * this.sectorSize);
  }

  getLengthY(units: number): number {
    return Math.round(units * this.sectorSize);
  }

  getPosition(position: Position): Position {
    const xPos = this.getX(position.x);
    const yPos = this.getY(position.y);
    return {
      x: xPos,
      y: yPos,
    };
  }
}
